/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_NameInputs */

const en_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const es_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const fr_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const nl_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

const it_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const pt_br2_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const pl_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa`)
};

const hu_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Név`)
};

const ro_admin_plan_discount_form_name = /** @type {(inputs: Admin_Plan_Discount_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nume`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Admin_Plan_Discount_Form_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_name = /** @type {((inputs?: Admin_Plan_Discount_Form_NameInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_NameInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_name(inputs)
	if (locale === "de") return de_admin_plan_discount_form_name(inputs)
	if (locale === "es") return es_admin_plan_discount_form_name(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_name(inputs)
	if (locale === "nl") return nl_admin_plan_discount_form_name(inputs)
	if (locale === "it") return it_admin_plan_discount_form_name(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_name(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_name(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_name(inputs)
	return ro_admin_plan_discount_form_name(inputs)
});
export { admin_plan_discount_form_name as "admin.plan_discount_form.name" }